import React, { useEffect } from "react";
import useAuth from "../../context/AuthProvider";
import { StateReportModel_Resp } from "../../models/StateReportModel";
import { StateReportsBillingModel } from "../../models/StateReportsBillingModel";
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, MenuItem, Select, Box, Typography, Paper, IconButton, Button } from "@mui/material";
import { Form, Formik } from "formik";
import { config } from "../../Constants";
import Swal from "sweetalert2";
import { FMTextField } from "../Elements/input";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const selectFieldSx = {
  width: '100%',
  '& .MuiSelect-select': { padding: '14.5px 16px' },
  '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};
const textFieldSx = {
  '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px !important' },
  '& .MuiInputBase-input': { padding: '5px 14px !important' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};


interface Iprops {
    StateRuleMatrixCL: StateReportsBillingModel,
    handleClose: () => void,
    Open: boolean,
    isStateReport: boolean,
    handleSubmit: () => void
    initValues: StateReportModel_Resp
    //selectedButton:number
}

export const EditStateReport: React.FC<Iprops> = ({ handleClose, Open, StateRuleMatrixCL, handleSubmit, initValues,isStateReport}) => {
    
    // Support both camelCase (list) and PascalCase (billing/API) so LargeReportFee is not stored as null
    const largeReportSrc = StateRuleMatrixCL?.largeReport ?? (StateRuleMatrixCL as any)?.LargeReport;
    const largeReportFeeSrc = StateRuleMatrixCL?.largeReportFee ?? (StateRuleMatrixCL as any)?.LargeReportFee;
    const hasLargeReportFee = largeReportFeeSrc !== undefined && largeReportFeeSrc !== null && largeReportFeeSrc !== '';

    const initialValues: StateReportsBillingModel = {
        ...StateRuleMatrixCL,
        largeReport: largeReportSrc,
        largeReportFee: (largeReportSrc === true || String(largeReportSrc).toLowerCase() === 'true') && hasLargeReportFee
                        ? largeReportFeeSrc
                        : ''
    };
    

    const { user } = useAuth();
    const token = user?.token;

    useEffect(() => {
        // fetchStateData();
    }, []);

    return (
        <Dialog
            open={Open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    width: '90%',
                    maxWidth: 900,
                    borderRadius: 2,
                    boxShadow: '0 24px 48px rgba(0,0,0,0.12)',
                },
            }}
            sx={{ '& .MuiDialog-paper': { overflow: 'hidden' } }}
        >
            <DialogTitle
                sx={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    py: 2,
                    px: 3,
                    background: 'linear-gradient(135deg, #0d4a63 0%, #15607a 100%)',
                    color: '#fff',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <AssessmentOutlinedIcon sx={{ fontSize: 28, opacity: 0.95 }} />
                    <Typography component="span" variant="h6" sx={{ fontWeight: 600, letterSpacing: '0.02em' }}>
                        State Report
                    </Typography>
                </Box>
                <IconButton
                    onClick={handleClose}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.12)' } }}
                    aria-label="Close dialog"
                >
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <Formik initialValues={initialValues}
                enableReinitialize={true}
                validateOnChange={true}
                onSubmit={(data, { setSubmitting }) => {
                    // data.partnerId = data.partnersId  // Not needed for StateReportsBillingModel
                    //data.largeReport = data.largeReport.toLowerCase() == 'true' ? true : false
                    data.largeReport = String(data.largeReport).toLowerCase() === 'true';
                    
                    fetch(
                        config + '/StateReport/AddEditStateReport',
                        {
                            method: 'POST',

                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            }),
                            body: JSON.stringify({
                                ...data,
                                stateReportId: StateRuleMatrixCL?.stateReportId ?? (StateRuleMatrixCL as any)?.StateReportId ?? 0,
                            }),
                        })
                        .then((response) => {
                            if (response.ok) {
                                
                                return response.json();
                                
                            }
                            throw new Error('Something went wrong');
                        })
                        .then((res) => {
                            setSubmitting(false)
                            Swal.fire({
                                title: "Data Successfully saved",
                                text: "",
                                icon: "success",
                                confirmButtonText: "OK",
                            }).then(() => {
                                handleSubmit(); // Call handleSubmit after user clicks OK
                                handleClose(); // Close the dialog
                            });
                          
                        }).catch((error) => {
                            setSubmitting(false);
                            console.log(error)
                        });
                }} >
                {({ values, isSubmitting, setFieldValue, errors }) => (
                    <Form className="main-form">
                        <DialogContent sx={{ width: '100%', overflow: 'auto', px: { xs: 2, sm: 3 }, py: 3 }}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, letterSpacing: '0.08em', display: 'block', mb: 1 }}>
                                        Report details
                                    </Typography>
                                    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, borderColor: 'divider', backgroundColor: 'grey.50' }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <FormHelperText className="formtexthelper-heading">Licensee</FormHelperText>
                                                    <FMTextField name="licensee" autoFocus margin="dense" disabled label={null} placeholder="Licensee" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <FormHelperText className="formtexthelper-heading">Client</FormHelperText>
                                                    {isStateReport ? (
                                                        <FMTextField name="client" margin="dense" disabled label={null} placeholder="client" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    ) : (
                                                        <FMTextField name="partnerName" margin="dense" disabled label={null} placeholder="client" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <FormHelperText className="formtexthelper-heading">License Number</FormHelperText>
                                                    <FMTextField name="licenseNumber" margin="dense" disabled label={null} placeholder="LicenseNumber" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <FormHelperText className="formtexthelper-heading">Report</FormHelperText>
                                                    {isStateReport ? (
                                                        <FMTextField name="report" margin="dense" disabled label={null} placeholder="report" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    ) : (
                                                        <FMTextField name="reportName" margin="dense" disabled label={null} placeholder="report" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <FormHelperText className="formtexthelper-heading">Payment</FormHelperText>
                                                    <FMTextField name="payment" margin="dense" disabled label={null} placeholder="payment" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <FormHelperText className="formtexthelper-heading">Due Date</FormHelperText>
                                                    <FMTextField name="dueDate" margin="dense" disabled label={null} placeholder="DueDate" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            {isStateReport && (
                                                <Grid item xs={12} md={6}>
                                                    <FormControl fullWidth>
                                                        <FormHelperText className="formtexthelper-heading">Status</FormHelperText>
                                                        <FMTextField name="status" margin="dense" disabled label={null} placeholder="Status" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    </FormControl>
                                                </Grid>
                                            )}
                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <FormHelperText className="formtexthelper-heading">Payment Type</FormHelperText>
                                                    <FMTextField name="paymentType" margin="dense" disabled label={null} placeholder="paymentType" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            {isStateReport && (
                                                <Grid item xs={12} md={6}>
                                                    <FormControl fullWidth>
                                                        <FormHelperText className="formtexthelper-heading">Notes To Client</FormHelperText>
                                                        <FMTextField name="notesToClient" margin="dense" label={null} placeholder="NotesToClient" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    </FormControl>
                                                </Grid>
                                            )}
                                            {isStateReport && (
                                                <Grid item xs={12} md={6}>
                                                    <FormControl fullWidth>
                                                        <FormHelperText className="formtexthelper-heading">Tax Reported</FormHelperText>
                                                        <FMTextField name="taxReported" margin="dense" label={null} placeholder="Tax Reported" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    </FormControl>
                                                </Grid>
                                            )}
                                            {isStateReport && (
                                                <Grid item xs={12} md={6}>
                                                    <FormControl fullWidth>
                                                        <FormHelperText className="formtexthelper-heading">Large Report</FormHelperText>
                                                        <Select
                                                            labelId="large-report"
                                                            name="largeReport"
                                                            value={values.largeReport ? String(values.largeReport).toUpperCase() : ''}
                                                            onChange={(event) => {
                                                                setFieldValue("largeReport", event.target.value);
                                                                if (event.target.value === 'FALSE') {
                                                                    setFieldValue("largeReportFee", '');
                                                                }
                                                            }}
                                                            label={null}
                                                            margin="dense"
                                                            fullWidth
                                                            variant="outlined"
                                                            sx={selectFieldSx}
                                                        >
                                                            <MenuItem value="TRUE">TRUE</MenuItem>
                                                            <MenuItem value="FALSE">FALSE</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            )}
                                            {!isStateReport && (values.largeReport === true || String(values.largeReport).toUpperCase() === 'TRUE') && (
                                                <Grid item xs={12} md={6}>
                                                    <FormControl fullWidth>
                                                        <FormHelperText className="formtexthelper-heading">Large Report Fee</FormHelperText>
                                                        <FMTextField
                                                            name="largeReportFee"
                                                            margin="dense"
                                                            label={null}
                                                            placeholder="Enter fee amount (e.g., 50.00)"
                                                            type="number"
                                                            fullWidth
                                                            variant="outlined"
                                                            sx={textFieldSx}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions
                            sx={{
                                px: 3,
                                py: 2,
                                gap: 1.5,
                                borderTop: 1,
                                borderColor: 'divider',
                                backgroundColor: 'grey.50',
                                flexWrap: 'wrap',
                            }}
                        >
                            <Button
                                variant="outlined"
                                size="medium"
                                onClick={handleClose}
                                startIcon={<CloseOutlinedIcon />}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    borderColor: '#e2e8f0',
                                    color: '#475569',
                                    '&:hover': {
                                        borderColor: '#2099d2',
                                        backgroundColor: '#2099d214',
                                        color: '#2099d2',
                                    },
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                size="medium"
                                type="submit"
                                disabled={isSubmitting}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    backgroundColor: '#2099d2',
                                    '&:hover': { backgroundColor: '#176990' },
                                    px: 2.5,
                                }}
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
